import {Toast, Dialog} from 'vant';

export default {
  methods: {

    /**
     * 提示弹窗
     */
    $showAlert(msg, confirm) {
      Dialog.alert({
        message: msg
      }).then(confirm)
    },

    /**
     * 确认弹窗
     */
    $showConfirm(msg, confirm, cancel) {
      Dialog.confirm({
        message: msg
      }).then(confirm)
        .catch(cancel);
    },

    /**
     * 显示Toast
     */
    $showToast(msg) {
      Toast(msg);
    },

    /**
     * 显示打钩消息
     */
    $showSuccess(msg) {
      Toast.success(msg);
    },

    /**
     * 显示打钩消息
     */
    $showFail(msg) {
      Toast.fail(msg);
    },

    /**
     * 显示Loading
     */
    $showLoading(msg) {
      Toast.loading({
        mask: true,
        duration: 0,
        loadingType: 'spinner',
        message: msg || '加载中...'
      });
    },

    /**
     * 不显示Loading
     */
    $removeLoading() {
      Toast.clear();
    },

    /**
     * 路由跳转带有params参数
     */
    $go(path, cache = true) {
      if (cache) {
        this.$router.push(path)
      } else {
        this.$router.replace(path)
      }
    },

    /**
     * 路由跳转带有params参数
     */
    $goDelay(path, cache = true) {
      let self = this;
      setTimeout(function () {
        if (cache) {
          self.$router.push(path)
        } else {
          self.$router.replace(path)
        }
      }, 1200)
    },

    /**
     * 路由回退或者历史回退
     */
    $back() {
      this.$router ? this.$router.back() : window.history.back();
    },

    /**
     * 路由回退或者历史回退
     */
    $backDelay() {
      let self = this;
      setTimeout(function () {
        self.$back();
      }, 1200)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js